import { useState } from "react";
import { StyledTextArea } from "./style";

export interface InputProps {
    getFormValues:any,
    labTaxInfo:any
  }

const EditPaymentInfo = ({getFormValues,labTaxInfo} : InputProps) =>{
    
    const [inputValues, setInputValue] = useState({
        economicCode:labTaxInfo.str_Economicode ? labTaxInfo.str_Economicode  : "",
        nationalCode:labTaxInfo.str_TaxnationalCode ? labTaxInfo.str_TaxnationalCode  : " ",
        postalCode:labTaxInfo.str_PostalCode ? labTaxInfo.str_PostalCode  : " ",
        ownerNatioalCode:labTaxInfo.str_TaxFullNameOwnernationalCode ? labTaxInfo.str_TaxFullNameOwnernationalCode  : " ",
        address:labTaxInfo.str_Address ? labTaxInfo.str_Address  : " ",
        telePhone:""
    });

    
    function handleChange(event: any) {       
        const { name, value } = event.target;       
        setInputValue({ ...inputValues, [name]: value });
        getFormValues(event);
    }
    return(
        <div>
            <div className="form-control"
                        style={{ marginBottom: '18px' }} >
                            <input
                            placeholder="کد ملی"
                            type="string"
                            autoComplete="false"
                            name="nationalCode"
                            id="nationalCode"
                            className="input-field"
                            onChange={(e) => handleChange(e)}
                            value={inputValues.nationalCode}
                            />                                           
            </div>
            <div className="form-control"
                        style={{ marginBottom: '18px' }} >
                            <input
                            placeholder="کد اقتصادی"
                            type="string"
                            autoComplete="false"
                            name="economicCode"
                            id="economicCode"
                            className="input-field"
                            onChange={(e) => handleChange(e)}
                            value={inputValues.economicCode}
                            />                                           
            </div>
            <div className="form-control"
                        style={{ marginBottom: '18px' }} >
                            <input
                            placeholder="نام کامل موسسه"
                            type="string"
                            autoComplete="false"
                            name="ownerNatioalCode"
                            id="ownerNatioalCode"
                            className="input-field"
                            onChange={(e) => handleChange(e)}
                            value={inputValues.ownerNatioalCode}
                            />                                           
            </div>
            <div className="form-control"
                        style={{ marginBottom: '18px' }} >
                            <input
                            placeholder="کد پستی"
                            type="string"
                            autoComplete="false"
                            name="postalCode"
                            id="postalCode"
                            className="input-field"
                            onChange={(e) => handleChange(e)}
                            value={inputValues.postalCode}
                            />                                           
            </div>
            <div className="form-control"
                        style={{ marginBottom: '18px' }} >
                            <StyledTextArea
                            placeholder="آدرس"
                            name="address"
                            id="address"
                            className="input-field"
                            onChange={(e) => handleChange(e)}
                            value={inputValues.address}
                            />                                           
            </div>
            <div className="form-control"
                        style={{ marginBottom: '18px' }} >
                            <input
                            placeholder="شماره تلفن"
                            type="string"
                            autoComplete="false"
                            name="telePhone"
                            id="telePhone"
                            className="input-field"
                            onChange={(e) => handleChange(e)}
                            value={inputValues.telePhone}
                            />                                           
            </div>
        </div>
    )
}

export default EditPaymentInfo;